import { FormLabel, type FormLabelProps, styled } from '@mui/material';
import { FORM_FIELD_LABEL_THEME_NAME } from '@onevision-resources/design-theme';
import { forwardRef } from 'react';

export type FormFieldLabelProps = Omit<FormLabelProps, 'required'>;

const FormFieldLabelRoot = styled(FormLabel, {
  name: FORM_FIELD_LABEL_THEME_NAME,
  slot: 'Root',
})(({ theme }) => {
  const { sys } = theme.palette.custom.OV;

  return {
    display: 'block',
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.5,
    color: sys.onBackground,
    marginBottom: theme.spacing(0.75),
    // FormLabel recolours itself from the FormControl state; this static label only dims when disabled.
    '&.Mui-focused, &.Mui-error': { color: sys.onBackground },
    '&.Mui-disabled': { color: sys.outline },
  };
});

export const FormFieldLabel = forwardRef<HTMLLabelElement, FormFieldLabelProps>(
  function FormFieldLabel(props, ref) {
    return <FormFieldLabelRoot ref={ref} {...props} required={false} />;
  },
);
